//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ViewBox, XHeader, Group, Cell } from 'vux'

export default {
  name: 'online',
  data () {
    return {
      onlineList: []
    }
  },
  methods: {
    select (username) {
      this.$router.replace({
        name: 'chat',
        query: {
          mode: 'push',
          title: username
        }
      })
    }
  },
  components: {
    ViewBox,
    XHeader,
    Group,
    Cell
  }
}
